<template>
  <div id="detail">
    <header class="header_imgs">一分鍾愛上原子幣</header>
    <div class="detail-content">
      <!-- <h1 class="details-title">小原子也可以點亮世界</h1> -->
      <div class="contents">
        <ul>
          <li v-for="(item,index) in detailsContent" :key="index">
            <h4 v-if="item.titles">{{item.titles}}</h4>
            <p>{{item.contents}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "details",
  data() {
    return {
      detailsContent: [
        {
          titles: "",
          contents:
            "基於原子鏈（ATOSHI）發行的原子幣（ATOS），定位是國與國之間交易往來的加密貨幣，其理論依據是，諾貝爾經濟學獎獲得者哈耶克的《貨幣的非國家化》。我們認為每個國家擁有自己的鑄幣權這是神聖不可侵犯的，這樣國家可以更好的調動經濟資源，建設國家。但是國與國之間的往來交易使用的貨幣，不應該由某一個國家來發行，而是應該由去中心化的區塊鏈網路發行，由世界人民自己控製。將來加密貨幣將可能成為國與國之間的外匯儲備和結算的貨幣，原子幣就是在這個大背景下孕育而生的。"
        },
        // {
        //   titles: "",
        //   contents:
        //     "原子鏈技術上將有新的突破。位元幣礦池佔有超過51%的算力，可以對位元網路全網攻擊，所以位元幣很難成為一個國家的外匯儲備。而原子鏈採用的更去中心化的POD算法，所謂POD算法是我們原子鏈首先命名的算法，這個算法在IOTA（前10名的加密貨幣）上麵有實現，但是冇有正式命名，即是Power Of Device的簡稱。交易0手續費，但是交易前需要幫整個網路處理兩筆交易。這樣我們用的人越多，算力越多，轉賬速度會越快。每個用戶都是一個節點，這樣我們的TPS是冇有上限的，遠超位元幣隻有7TPS,以太坊隻有15TPS，以及EOS的“百萬”TPS…而且0手續費，不需要挖礦。礦池都冇有，何必有礦池控製全網算力的51%的煩惱？永遠都是高度去中心化。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "原子鏈技術上將有新的突破。位元幣礦池佔有超過51%的算力，可以對位元網路全網攻擊，所以位元幣很難成為一個國家的外匯儲備。而原子鏈採用的更去中心化的POD算法，所謂POD算法是我們原子鏈首先命名的算法，這個算法在IOTA（前10名的加密貨幣）上麵有實現，但是冇有正式命名，即是Power Of Device的簡稱。交易0手續費，但是交易前需要幫整個網路處理兩筆交易。這樣我們用的人越多，算力越多，轉賬速度會越快。每個用戶都是一個節點，這樣我們的TPS是冇有上限的，遠超位元幣隻有7TPS,以太坊隻有15TPS，以及EOS的“百萬”TPS…而且0手續費，不需要挖礦。礦池都冇有，何必有礦池控製全網算力的51%的煩惱？永遠都是高度去中心化。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "原子鏈將採用實名製。以後大家不用擔心丟失錢包密碼，通過驗證身份，指紋，刷臉驗證，丟了密碼，丟了手機也可以高枕無憂找回來。各個國家也不用擔心犯罪份子通過原子鏈網路做不法交易，符合各國監管，更利於社會安全和穩定。另外原子鏈將打造成區塊鏈中的底層操作係統，也就是說可以在原子鏈的上開發各種Dapp,而且用戶界麵非常友好，簡單易用，點選菜單即可。這樣的話，各個行業都可以在我們的原子鏈上開發自己的鏈，跟原子鏈是並行鏈，冇有誰是主鏈誰是側鏈，大家平等。各條鏈之間又可以跨鏈用原子幣ATOS進行價值支付。同時還有跨鏈去中心化錢包，支援指紋刷臉識別。各個行業都可以加入原子鏈打造的去中心化操作係統, 這樣我們的原子幣ATOS基本應用場景會非常廣闊，變成世界的硬通貨。最終為國際認可，形成一種國家之間可以自由使用秒級到賬，不可增發的優勢貨幣。世界人民已經感覺到美元不斷增發剪各國羊毛的煩惱，良幣驅逐，世界人民最終會做出拋棄美金決定。從此國際支付就用加密貨幣，原子幣很有可能成為幸運兒。"
        // },
        // {
        //   titles: "",
        //   contents:
        //     "據有關數據統計，國與國之間使用的貨幣和外匯儲備，規模超200萬億美金。原子幣定位就是這種加密貨幣之一。如果我們佔到市場1%，那麼我們的市值將是2萬億美元，將成為世界上市值最大的公司，原子鏈將為原子幣的發展提供區塊鏈基礎平臺。原子鏈將具有以下魔法特點："
        // },
          {
            titles: "",
            contents:
              "原子鏈將以下魔法特點作為奮鬥目標："
          },
        {
          titles: "1.理想很豐滿。原子鏈，愛國鏈。",
          contents:
            "我們用區塊鏈去中心化實現佈雷頓森林體係當年的願景。加密貨幣的産生將讓任何一個國家收其他國家的鑄幣稅成為曆史，讓國家和國家之間更加平等。"
        },
        {
          titles: "",
          contents:
            "區塊鏈是通嚮未來的技術，位元幣啓蒙下的一係列加密貨幣，可以重塑世界金融格局，提高國際支付生産效率，減低支付成本，讓各國人民更加平等的參與世界金融，進而可能讓各國經濟實力大洗牌。我國憑借強大的實體經濟，加上更加平等的國際金融環境，在一定程度上有助於大國崛起。我們將用區塊鏈給産業賦能，助力大國崛起。"
        },
        {
          titles: "2.現實很骨感。原子鏈，實幹鏈。",
          contents:
            "原子鏈要實現的技術願景是：交易速度快，低交易費用，實名製，配合各國監管，數量有限，分佈式記賬。"
        },
        {
          titles: "",
          contents:
            "就像當年手機有諾基亞有摩托羅拉一樣，喬佈斯覺得應該有個更好的手機叫iphone。我們也認為位元幣是10多年前發明的，10年後肯定有更好的技術可以超越他。有很多數字貨幣都很優秀，但是缺乏一款數字貨幣中的 “蘋果手機” ，這就是我們奮鬥的方嚮。"
        },
        {
          titles: "",
          contents:
            "我們踏實用區塊鏈去解決現在黃金，位元幣還有其他加密貨幣的痛點，一個個問題去踏實解決，讓用戶更方便、更好用。"
        },
        {
          titles: "",
          contents:
            "位元幣tps隻有7，以太坊tps隻有15，網路經常擁堵......加密貨幣發展尚處於早期，實幹的我們一起引導這個新行業給世界賦能。"
        },
        // {
        //   titles: "",
        //   contents:
        //     "目前，國際轉賬至少要3天，且手續費昂貴。如果在國外發生車禍，立即要做手術，生命垂危，否則錯過搶救時間。手術的巨款需要國際轉賬，生命就會因此凋零。我們一起貢獻一份力量！ATOS轉賬可以秒到，無論你在地球任何一個角落。不用出門，零成本立即到賬。"
        // },
        {
          titles: "3.定位大格局。原子鏈，格局鏈。",
          contents:
            "ATOS定位為國與國之間支付的加密貨幣，我們用區塊鏈技術去實現佈雷頓森林體係的美好願景，也就是一種相對公平易用的國際通用貨幣。"
        },
          {
              titles: "",
              contents:
                  "國與國之間通用的貨幣和外匯儲備，規模超200萬億美金。如果我們佔到市場1%，那麼我們的市值將是2萬億美元，將成為世界上市值最大的公司。"
          },
          {
              titles: "",
              contents:
                  "原子幣定位就是這種大格局的加密貨幣。"
          },
        {
          titles: "4.團隊有信仰。原子鏈，信仰鏈。",
          contents: ""
          // contents:
          //   "創始團隊通證也鎖倉3年不能交易，三年之後隻能每年釋放團隊份額的20%，釋放完全需要8年。原子基金會鎖倉每年釋放不得超過其份額10%，至少10年才能釋放完。"
        },
        {
          titles: "",
          contents:
            "我們認為解決社會痛點，實現讓社會更美好的理想是第一的。我們用鋼鐵的意誌去努力，我們吸引最優秀的人才加入我們IMFO，一起推動區塊鏈行業正嚮發展。我們做好精神文明建設的同時，也註重所有成員的物質文明，一起讓世界更美好的同時讓自己更美好。"
        },
        {
          titles: "5.價值超靠譜。原子鏈，價值鏈。",
          contents:
            "原子鏈項目的收入部分用來回購原子幣，還有部分將投資各種公司，要求他們在條件成熟的時候接受原子幣進行支付。這樣我們將持有很多高增長公司的股份，變成一個大麥克區塊鏈投行。"
        },
          {
              titles: "",
              contents:
                  "騰訊之所以強大，離不開他投資了很多公司。我們投資的公司都將使用原子幣作為支付手段，而且是打摺支付，就形成了一個多行業的廣泛應用原子幣的場景，成為一種不可增發的秒級到賬的優勢貨幣。"
          },
          {
              titles: "",
              contents:
                  "位元幣，以太坊，瑞波幣等都冇有實體資産支撐，不夠“硬“，我們原子幣將“硬”氣到底。位元幣增值了2600萬倍，原子幣站在這些巨人的肩膀上進行更好的創新，青出於藍，發展潛力巨大。"
          },
        {
          titles: "結束語：",
          contents:
            "原子鏈的願景是站在位元幣巨人的肩膀上，進行一定的創新和改進。跟黃金還有位元幣一樣，這些産品的優點我們都要有，但他們的缺點我們將進行改進。"
        },
        {
          titles: "",
          contents:
            "目前，國際轉賬至少要3天，且手續費昂貴。如果在國外發生車禍，立即要做手術，生命垂危，否則錯過搶救時間。手術的巨款需要國際轉賬，生命就會因此凋零。我們一起貢獻一份力量！ATOS轉賬可以秒級到賬，無論你在地球任何一個角落。不用出門，低成本立即到賬。"
        },
          {
              titles: "",
              contents:
                  "區塊鏈是通嚮未來的技術。IMFO及原子鏈用區塊鏈可以更加公平高效，降低成本。區塊鏈正在改變世界，小原子也可以點亮世界。"
          },
      ]
    };
  }
};
</script>

<style scoped>
.header_imgs {
  background: url('/static/img/sjasyzb.png') no-repeat
    center center;
  background-size: cover;
  width: 100%;
  font-size: 0.42rem;
  text-align: center;
  line-height: 1.2rem;
  color: #fff;
}
.detail-content {
  background-color: #f5f5f5;
  color: #222;
}
.details-title {
  width: 90%;
  margin: 0 auto;
  padding: 0.5rem 0;
  font-size: 0.32rem;
  text-align: center;
}
.contents h4 {
  box-sizing: border-box;
  padding: 0.3rem 0.4rem;
  width: 100%;
  background-color: #fff;
}
.contents p {
  box-sizing: border-box;
  padding: 0.2rem 0.4rem;
  line-height: 0.5rem;
}
li:nth-last-of-type(1) {
  padding-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/Details.vue